export let ToTitleChar = function (str) {
    return str.replace(
        /\w\S*/g,
        function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
    );
}

export let ToReadNumber = function (num) {
    if (num === 0) {
        return num
    }
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}